export const NON_APPLICABLE = 'N/A';
export const PLAN_TYPE_SOURCE = 'source';
export const PLAN_TYPE_DESTINATION = 'destination';
export const NEW_PLAN_ID = 'newPlan';
export const NEW_BANK_ACCOUNT_ID = 'NEW BANK ACCOUNT';

export const isPlaceholderPotId = (id: string | undefined | null): boolean =>
  id === NEW_PLAN_ID || id === NEW_BANK_ACCOUNT_ID;
